/**
 * @generated SignedSource<<3d7a584cd69cbf2862c9d9e7f3d8c0f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type abTestOffersOnHp_buyerActivePrivateOffers$data = {
  readonly totalResults: number | null;
  readonly " $fragmentType": "abTestOffersOnHp_buyerActivePrivateOffers";
};
export type abTestOffersOnHp_buyerActivePrivateOffers$key = {
  readonly " $data"?: abTestOffersOnHp_buyerActivePrivateOffers$data;
  readonly " $fragmentSpreads": FragmentRefs<"abTestOffersOnHp_buyerActivePrivateOffers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "abTestOffersOnHp_buyerActivePrivateOffers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "BuyerActivePrivateOffersConnection",
  "abstractKey": null
};

(node as any).hash = "045a02e038029c946a4dbc5eadda9435";

export default node;
